import { differenceInHours, getDaysInMonth } from 'date-fns';

function calculateDaysLeft(expiredDate: Date, today: Date) {
  const calculatedDaysLeft = Math.ceil(differenceInHours(expiredDate, today) / 24);
  const currentDaysInMonth = getDaysInMonth(today);
  let daysLeft = 0;

  if (calculatedDaysLeft > currentDaysInMonth) {
    daysLeft = currentDaysInMonth;
  } else {
    daysLeft = calculatedDaysLeft;
  }

  return daysLeft;
}

export { calculateDaysLeft };
